import StandardTabPanel from "../../../../ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ providerId, activeTab, children }) {
  const allTabs = [
    {
      key: "entity-info",
      name: "Entity Info",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/management/entity-info`,
    },
    {
      key: "network-settings",
      name: "Network Settings",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/management/network-settings`,
    },
    {
      key: "internal-notes",
      name: "Internal Notes",
      isDisabled: false,
      permission: null,
      href: `/provider/${providerId}/management/internal-notes`,
    },
  ];

  return (
    <StandardTabPanel
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="flex h-full min-h-0 flex-col p-4">{children}</section>
    </StandardTabPanel>
  );
}
